import React, { useState, useEffect } from "react";
import question from "../images/question.png";
import spark from "../images/spark.png";
import upload from "../images/upload_photo.svg";
import upload2 from "../images/upload_photo2.png";
import shield from "../images/Shield.png";

import Proceed from "./Proceed";
import clock from "../images/clock.svg";
import { useMyContext } from "../../AppContext";
import mixpanel from "mixpanel-browser";
import { useNavigate } from "react-router-dom";

// console.log(window.innerWidth, "widthh");

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: true });

export default function Bankstatements({ userData, Error }) {
  const [show, setshow] = useState(0);
  const { Storage, SetStorage } = useMyContext();
  const navigate = useNavigate();

  useEffect(() => {
    // console.log(Error);
    if (Error) {
      navigate("/finalresult");
    }
    if (userData) {
      Storage.userid = userData.username;
      Storage.consentHandle = userData.consentHandle;
      Storage.mobilenumber = userData.mobileNum;

      SetStorage(Storage);
    }
  }, [userData]);
  
  // console.log(Storage);
  const handleClick = (e) => {
    e.preventDefault();
    setshow(1 - show);
    if (!show) {
      document.getElementById("root").style.backgroundColor =
        "rgba(0, 0, 0, 0.2)";
    }
    mixpanel.track("Viewed_BS_Process_Pop_Up", {
      Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
    });
  };

  return (
    <div className="bankstatement" id={show ? "blurbackground" : ""}>
      <div className="mybody">
        <div className="text">
          <div className="image">
            <img className="image" src={question}></img>
          </div>
          <div className="some_text">
            <p>
              Please share the bank account statement of your primary account,
              where most of your earnings/<br></br> income/salary is credited,
              for the last 6 months.
            </p>
          </div>
        </div>

        <div className="upper_middle">
          <h1>Choose one to continue</h1>
          <button>RECOMMENDED</button>
        </div>

        <div className="middlecontainer">
          <div className="statement">
            <h1>E-Statement</h1>
            <div className="option">
              <p>
                Opted by <span>90% </span>users
              </p>
            </div>
          </div>
          <p>
            Verification will just take <span>30 seconds</span>{" "}
            <img src={spark}></img> <br></br> <span>Instant</span> Loan Approval
          </p>
          <div className="submitbtn">
            <button className="submit" onClick={handleClick}>
              <img src={upload}></img>
              <h1>E-Statement</h1>
            </button>
          </div>
        </div>

        <div className="slider">
          <hr className="line" />
          <span>OR</span>
          <hr className="line" />
        </div>

        <div className="upload_container">
          <h1>Upload Statement</h1>
          <p>
            Verification will take <span>2-3 Business hours </span>{" "}
            <img src={clock}></img> <br></br>
            Loan Approval in <span> 24 Hours </span>
          </p>
          <div className="submitbtn">
            <button className="submit">
              <img src={upload2}></img>
              <p>Upload statement</p>
            </button>
          </div>
        </div>

        <div className="footer">
          <img src={shield}></img>
          <p>Your data is 100 % safe and secure</p>
        </div>
      </div>

      {show ? <Proceed /> : <></>}
    </div>
  );
}
